import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInterceptorInstance from "./axiosInterceptorInstance";
import { FeatureConfig } from "@/types/Features";

export const getFeatures = createAsyncThunk('features', async () => {
    try {
        const response = await axiosInterceptorInstance.get<FeatureConfig>('/features');
        return response.data;
    } catch (error) {
        return error;
    }
});